import logo from './logo.svg';
import logoJpg from './logo.jpg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <img src={logoJpg} className="App-logo" alt="logo" />
      </header>
    </div>
  );
}

export default App;
